"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardContainer = exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("block/base"));

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _carousel = babelHelpers.interopRequireDefault(require("carousel"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _temp2;

var LinkListBlock = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(LinkListBlock, _Block);

  function LinkListBlock() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, LinkListBlock);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(LinkListBlock)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "hideTitle", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "titleColor", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "title", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "customHeader", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "displayMode", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "content", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "asCarousel", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.state = Object.assign(_this2.state, {
      ready: false
    });
    return _this2;
  }

  babelHelpers.createClass(LinkListBlock, [{
    key: "renderFooter",
    value: function renderFooter() {
      return null;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      babelHelpers.get(babelHelpers.getPrototypeOf(LinkListBlock.prototype), "componentDidMount", this).call(this);
      this.setState({
        ready: true
      });
    }
  }, {
    key: "renderCustomHeader",
    value: function renderCustomHeader(markup) {
      if (this.state.ready && typeof document !== 'undefined') {
        var x = document.createElement('div');
        x.innerHTML = markup;
        var r = [];

        for (var i = 0; i < x.childNodes.length; i++) {
          if (x.childNodes[i].nodeType == 3) r.push(x.childNodes[i].textContent);else {
            var n = {};

            for (var j = 0; j < x.childNodes[i].attributes.length; j++) {
              var attr = x.childNodes[i].attributes[j];
              if (attr.nodeName == 'class') n.className = attr.nodeValue;else n[attr.nodeName.toLowerCase()] = attr.nodeValue;
            }

            n.dangerouslySetInnerHTML = {
              __html: x.childNodes[i].innerHTML
            };
            n.key = i;
            r.push(_react.default.createElement(x.childNodes[i].nodeName.toLowerCase(), n));
          }
        }

        return r;
      }

      return _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: markup
        }
      });
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      try {
        debug(this.props);
      } catch (e) {
        ;
      }

      return _react.default.createElement("div", {
        className: "inner-content"
      }, !this.hideTitle && this.title && _react.default.createElement("div", {
        className: "container"
      }, _react.default.createElement("h1", {
        style: this.titleColor ? {
          color: this.titleColor
        } : {}
      }, this.title)), this.customHeader && this.renderCustomHeader(this.customHeader), this.displayMode === 'pills' && _react.default.createElement("div", {
        className: "tab-container"
      }, this.content.map(function (node) {
        return _react.default.createElement("a", {
          key: node.id,
          className: _classList.default.join('item', node.isCurrentObject && 'active'),
          href: node.linkTarget
        }, node.objectTitle);
      })), this.displayMode !== 'none' && this.displayMode !== 'pills' && _react.default.createElement(CardContainer, {
        displayMode: this.displayMode,
        content: this.content,
        carousel: this.asCarousel
      }), this.renderFooter());
    }
  }]);
  return LinkListBlock;
}(_base.default), _temp2), (_descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "hideTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "titleColor", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "customHeader", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "displayMode", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "asCarousel", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class3);
exports.default = LinkListBlock;
var CardContainer = (_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  babelHelpers.inherits(CardContainer, _React$Component);

  function CardContainer() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CardContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CardContainer)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "displayMode", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "content", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "carousel", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(CardContainer, [{
    key: "render",
    value: function render() {
      var props = {
        className: _classList.default.join('card-container card-centered', this.displayMode == 'card' ? 'card-grid' : 'card-tile'),
        children: this.content.map(function (card) {
          return _react.default.createElement(require(card.child_type).default, Object.assign({
            key: card.id
          }, card));
        })
      };

      if (this.carousel) {
        props.listClassName = props.className;
        delete props.className;
        return _react.default.createElement("div", null, _react.default.createElement(_carousel.default, props));
      }

      return _react.default.createElement("div", props);
    }
  }]);
  return CardContainer;
}(_react.default.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "displayMode", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "carousel", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.CardContainer = CardContainer;